"use client";

import * as React from 'react';
import { cn } from '@/shared/lib/utils';

export const ETextarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
    function ETextarea({ className, onWheelCapture, onFocus, onBlur, ...props }, ref) {
        const [focused, setFocused] = React.useState(false);

        const handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
            setFocused(true);
            if (onFocus) onFocus(e);
        };

        const handleBlur = (e: React.FocusEvent<HTMLTextAreaElement>) => {
            setFocused(false);
            if (onBlur) onBlur(e);
        };

        return (
            <textarea
                ref={ref}
                className={cn(
                    'scrollbar-subtle min-h-[128px] w-full border border-border bg-panel px-2 py-2 text-sm leading-6 text-foreground outline-none placeholder:text-muted focus-visible:ring-2 focus-visible:ring-accent',
                    focused && 'nowheel',
                    className,
                )}
                onFocus={handleFocus}
                onBlur={handleBlur}
                {...props}
            />
        );
    },
);

ETextarea.displayName = 'ETextarea';